<template lang="pug">
//- Card do "Nível de destaque" da tela de Marketing.
//- Variante verde (padrão) e dourada quando o nível está em 100% (Estrela Bigou).
.nivelCard(v-if="loading")
  .nivelCard__skeleton
.nivelCard(v-else, :class="{ 'nivelCard--estrela': isEstrela }")
  .nivelCard__sparkles(v-if="isEstrela") ✦ ✦ ✦
  .nivelCard__top
    .nivelCard__main
      .nivelCard__emoji {{ nivelInfo.nivel.emoji }}
      .nivelCard__titles
        .nivelCard__kicker.Poppins NÍVEL DE DESTAQUE{{ isEstrela ? ' · 100%' : '' }}
        .nivelCard__nome.Poppins {{ nivelInfo.nivel.nome }}{{ isEstrela ? '!' : '' }}
        .nivelCard__desc.Poppins(v-if="isEstrela") Nível máximo! Sua loja ganhou o selo Super Bigou e está no topo da vitrine do app.
    .nivelCard__side(v-if="!isEstrela && nivelInfo.proximoNivel")
      .nivelCard__proximo.Poppins
        | Ative #[b {{ nivelInfo.acoesParaProximoNivel }} {{ nivelInfo.acoesParaProximoNivel > 1 ? 'ações' : 'ação' }}] para virar #[b {{ nivelInfo.proximoNivel.emoji }} {{ nivelInfo.proximoNivel.nome }}] e subir na vitrine do app
  .nivelCard__barra
    .nivelCard__barra-fill(:style="{ width: barraWidth }")
    .nivelCard__barra-marco(v-for="marco in marcos", :key="marco", :style="{ left: marco + '%' }")
  .nivelCard__legenda
    span.Poppins(
      v-for="n in niveis",
      :key="n.key",
      :class="{ 'nivelCard__legenda-atual': n.key === nivelInfo.nivel.key }"
    ) {{ n.emoji }} {{ n.nome }} · {{ n.min }}%
  .nivelCard__resumo.Poppins {{ textoResumo }}
</template>

<script>
import { NIVEIS } from '@/util/nivelDestaque';

export default {
  name: 'NivelDestaqueCard',
  props: {
    nivelInfo: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
  computed: {
    niveis() {
      return NIVEIS;
    },
    isEstrela() {
      return this.nivelInfo.percentual === 100;
    },
    marcos() {
      return NIVEIS.filter(n => n.min > 0).map(n => n.min);
    },
    barraWidth() {
      // Mínimo de 3% para a barra ser visível mesmo em 0%.
      return Math.max(3, this.nivelInfo.percentual) + '%';
    },
    textoResumo() {
      const info = this.nivelInfo;
      const base = `${info.acoesAtivas} de ${info.acoesTotais} ${info.acoesTotais === 1 ? 'ação ativa' : 'ações ativas'}`;
      if (this.isEstrela) {
        return `${base} — mantenha tudo ativo para conservar o selo`;
      }
      if (!info.acoesTotais) {
        return 'Nenhuma ação disponível no momento — novas ofertas aparecem aqui assim que forem liberadas';
      }
      return `${base} — cada cupom ou promoção ativa aumenta seu nível de destaque`;
    },
  },
};
</script>

<style lang="scss" scoped>
.nivelCard {
  position: relative;
  background: #1E9E57;
  border-radius: 16px;
  padding: 18px 22px;
  overflow: hidden;

  &--estrela {
    background: #15713E;
    border: 2px solid #FFD34D;
  }

  &__sparkles {
    position: absolute;
    top: 12px;
    right: 18px;
    font-size: 15px;
    color: #FFD34D;
  }

  &__skeleton {
    height: 120px;
    border-radius: 12px;
    background: linear-gradient(90deg, rgba(255,255,255,0.14) 25%, rgba(255,255,255,0.24) 50%, rgba(255,255,255,0.14) 75%);
    background-size: 200% 100%;
    animation: nivelShimmer 1.2s infinite;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
  }
  &__main {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
  }
  &__emoji {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }
  &--estrela &__emoji {
    background: #FFD34D;
    box-shadow: 0 0 0 5px rgba(255, 211, 77, 0.25);
  }
  &__kicker {
    color: rgba(255, 255, 255, 0.75);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
  }
  &--estrela &__kicker { color: #FFD34D; }
  &__nome {
    color: #fff;
    font-weight: 700;
    font-size: 18px;
  }
  &--estrela &__nome { font-weight: 800; }
  &__desc {
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    margin-top: 2px;
    line-height: 1.4;
  }
  &__side { flex-shrink: 0; }
  &__proximo {
    background: rgba(255, 255, 255, 0.14);
    border-radius: 10px;
    padding: 8px 14px;
    color: #fff;
    font-size: 11.5px;
    max-width: 260px;
    line-height: 1.45;
  }
  &__barra {
    position: relative;
    margin-top: 14px;
    height: 8px;
    background: rgba(255, 255, 255, 0.22);
    border-radius: 999px;
  }
  &__barra-fill {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: #FFD34D;
    border-radius: 999px;
    transition: width 0.4s ease;
  }
  &__barra-marco {
    position: absolute;
    top: -2px;
    width: 12px;
    height: 12px;
    margin-left: -6px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 999px;
  }

  &__legenda {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px 8px;
    margin-top: 8px;
    font-size: 12.5px;
    font-weight: 600;
    color: #ffffff;
  }
  &__legenda-atual {
    font-weight: 700;
    color: #FFD34D;
  }

  &__resumo {
    margin-top: 8px;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.75);
  }

  @media (max-width: 768px) {
    &__top { flex-wrap: wrap; }
  }
}

@keyframes nivelShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
